import React, { lazy } from "react";
import Loadable from "../components/Loadable";
// import { authRoles } from "../auth/authRoles";
import { routeCheck } from "app/data/roles";

const UserProfileSettins = Loadable(lazy(() => import('app/views/profile/UserProfileSettings')));

const profilePaths = routeCheck(
    [ 
       { path: "/profile/settings", element: <UserProfileSettins/> },
    ], 
    false 
)

export default profilePaths;